import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { isAuthenticated } from './shared/guards/auth.guard';
import {
  AutoSignInComponent,
  OUTLAW_ROUTES,
  PaymentCancelComponent,
  QueryParamsResolver,
  UserTokenResolver,
} from '@outlaw/core';
import { postResolver } from '@outlaw/community';
import { userProfileUpdateResolver } from './core/resolvers/user-profile-update.resolver';
import { userDetailsResolver } from './core/resolvers/user-details.resolver';

const userProfileResolvers = {
  userDetails: userDetailsResolver,
  userProfileUpdate: userProfileUpdateResolver,
};

const postRoutes: Routes = [
  {
    path: OUTLAW_ROUTES.post,
    loadComponent: () =>
      import('@app/posts/post.component').then((m) => m.PostComponent),
    resolve: {
      post: postResolver(),
      userProfileUpdate: userProfileUpdateResolver,
    },
  },
];

const widgetRoutes: Routes = [
  {
    path: 'widgets/calendar',
    loadComponent: () =>
      import(
        '@app/widget-pages/calendar-events-page/calendar-events-page.component'
      ).then((m) => m.CalendarEventsPageComponent),
  },
  {
    path: 'widgets/latest-videos',
    loadComponent: () =>
      import(
        '@app/widget-pages/latest-videos-page/latest-videos-page.component'
      ).then((m) => m.LatestVideosPageComponent),
  },
];

const layoutRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@app/community/community.module').then((m) => m.CommunityModule),
    resolve: userProfileResolvers,
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('@app/profile/profile.module').then((m) => m.ProfileModule),
    resolve: userProfileResolvers,
  },
  ...postRoutes,
  ...widgetRoutes,
  {
    path: 'chat',
    loadComponent: () =>
      import('@app/chat/components/chat/chat.component').then(
        (m) => m.ChatComponent,
      ),
  },
  {
    path: OUTLAW_ROUTES.subscribe,
    canActivate: [isAuthenticated],
    loadComponent: () =>
      import('@app/subscribe/subscribe.component').then(
        (m) => m.SubscribeComponent,
      ),
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('@outlaw/community').then((m) => m.NotFoundComponent),
  },
  { path: '**', pathMatch: 'full', redirectTo: 'not-found' },
];

const defaultRoutes: Routes = [
  {
    path: 'auto_signin',
    component: AutoSignInComponent,
    resolve: {
      queryParams: QueryParamsResolver,
      user: UserTokenResolver,
    },
  },
  {
    path: 'payments/success',
    component: AutoSignInComponent,
    resolve: {
      queryParams: QueryParamsResolver,
      user: UserTokenResolver,
    },
  },
  {
    path: 'payments/cancel',
    component: PaymentCancelComponent,
  },
  {
    path: '',
    loadComponent: () =>
      import(
        '@app/layout/components/community-layout/community-layout.component'
      ).then((m) => m.CommunityLayoutComponent),
    children: layoutRoutes,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(defaultRoutes, {
      useHash: false,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    } as ExtraOptions),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
